export default __webpack_public_path__ + "static/media/noe-display-bold.506bfca4.eot";